import React from "react";
import Helmet from "react-helmet";
import {graphql} from "gatsby";

import "../styles/main.scss";
import {Header} from "./Header";
import {Footer} from "./Footer";

const TemplateWrapper = ({footerData = null, navbarData = null, siteMetadata = null, children}) => (
    <div className="html-wrapper">
        <Helmet>
            <html lang="en"/>
            <meta name="keywords" content="montreal, javascript, programming, meetup"/>
            <meta name="google" content="notranslate"/>
            <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
            <meta name="viewport" content="width=device-width, initial-scale=1"/>
            <meta http-equiv="content-language" content="en-US"/>
        </Helmet>

        <Header data={navbarData} siteMetadata={siteMetadata}/>
        <main>{children}</main>
        <Footer data={footerData} siteMetadata={siteMetadata}/>
    </div>
);

export const query = graphql`
    fragment LayoutFragment on Query {
        metaData: allMarkdownRemark(filter: {
            frontmatter: {
                templateKey: { eq: "metafields" }
            }
        }
        ) {
            edges {
                node {
                    id
                    frontmatter {
                        generalMetaData
                        generalSchemaScripts {
                            script
                            type
                        }
                        fields {
                            type
                            value
                            content
                        }
                        googleAnalyticsTracker
                        mailchimpTracker
                    }
                }
            }
        }
        navbarData: allMarkdownRemark(
            filter: {
                frontmatter: {
                    templateKey: { eq: "navbar" }
                }
            }
        ) {
            edges {
                node {
                    id
                    frontmatter {
                        menuItems {
                            label
                            linkType
                            linkURL
                            highlight
                            menuItemsLevel2 {
                                label
                                linkType
                                linkURL
                                column
                                menuItemsLevel3 {
                                    label
                                    linkType
                                    linkURL
                                }
                            }
                        }
                    }
                }
            }
        }
        footerData: allMarkdownRemark(filter: { frontmatter: { templateKey: { eq: "footer" } } }) {
            edges {
                node {
                    id
                    frontmatter {
                        title
                        privacyPolicy {
                            url
                            label
                        }
                        termsConditions {
                            url
                            label
                        }
                        socialLinks {
                            image
                            imageAlt
                            label
                            linkURL
                        }
                    }
                }
            }
        }

        trackerData: site {
            siteMetadata {
                googleAnalyticsTracker
                mailchimpTracker
            }
        }
    }
`;

export default TemplateWrapper;
